import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <svg 
      className={className}
      fill="none" 
      height="299" 
      viewBox="0 0 500 299" 
      width="500" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={isDark ? "#fff" : "#000"}>
        <path d="m0 0v57.5 82.5h59.3v-140z"/>
        <path d="m241.7 121.6h-19.5v-41.6h-21.8v60h41.3z"/>
        <path d="m281.4 97.3981c7.8 0 11.4 5.9999 11.4 12.5999s-3.6 12.6-11.4 12.6-11.4-6-11.4-12.6 3.6-12.5999 11.4-12.5999zm0 44.6999c21.5 0 34.1-15.1 34.1-32.1 0-16.8999-12.6-32.0999-34.1-32.0999s-34.1 15.1-34.1 32.0999c0 17 12.6 32.1 34.1 32.1z"/>
        <path d="m358.2 142.098c19.8 0 32.3-12.5 32.3-30.4 0-2.6-.3-6.2-.3-6.2h-32.4v11.6h11.5s-2.7 6.5-11 6.5c-9.1 0-12.7-5.7-12.7-14.5 0-9 4.3-14.0999 11.7-14.0999 4.7 0 8.1 1.8 8.9 4.7h23.8c-.9-13.3-13.8-21.8-32.8-21.8-20.5 0-34.2 12.9-34.2 32.0999 0 20.6 15.5 32.1 35.2 32.1"/>
        <path d="m401.1 139.998h21.8v-59.9999h-21.8z"/>
        <path d="m466.2 122.698c-7.3 0-11.7-4.8-11.7-12.7s4.4-12.6999 11.7-12.6999c6 0 10.1 2.7999 11 6.8999h22.8c-1.3-17.1999-14.1-26.2999-33.8-26.2999-19.9 0-34.3 13.4-34.3 32.0999 0 18.7 14.4 32.1 34.3 32.1 19.7 0 32.6-9.2 33.8-26.3h-22.8c-.8 4.1-5 6.9-11 6.9z"/>
        <path d="m238.4 161.598h-21.6v35c0 4.3-2.5 7.1-6.5 7.1-3.8 0-6-2.1-6-2.1l-11.3 15.5s6.1 6.1 17.7 6.1c16 0 27.8-7.1 27.8-26.3v-35.3z"/>
        <path d="m281.4 203.998c-7.8 0-11.4-6-11.4-12.6s3.6-12.6 11.4-12.6 11.4 6 11.4 12.6-3.6 12.6-11.4 12.6zm0-44.6c-21.5 0-34.1 15.1-34.1 32.1 0 16.9 12.6 32.1 34.1 32.1s34.1-15.1 34.1-32.1-12.6-32.1-34.1-32.1z"/>
        <path d="m365.3 205.698h-18.3v-8h18.3v-11.6h-18.3v-8.9h18.3v-15.6h-40.1v59.7h40.1z"/>
        <path d="m80.9 210.698c0 13.1-6.4 24.9-23.3 24.9-15.5 0-23.2-9-23.2-9l-34.4 55.7s18.5 26.3 65.8 26.3c45.9 0 74.4-35.3 74.4-80.7l.1-56.3h-59.4z"/>
      </g>
      <path d="m80.9 139.998h59.5v-59.9999h-59.5z" fill="#ffe600"/>
    </svg>
  );
};

export default Logo;
